import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractHttpService } from 'src/app/commons/abstract-http.service';

@Injectable({
  providedIn: 'root'
})
export class AtivacaoTokenService extends AbstractHttpService {

  private readonly END_POINT_BASE = 'token';
  private readonly VALIDAR_TOKEN = 'validar-codigo';
  private readonly GERAR_TOKEN = 'gerar';


  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  validarCodigo(token: string, email: string) { 
    return this.getMethod(`${this.END_POINT_BASE}/${this.VALIDAR_TOKEN}/${token}/${email}`)
  }

  gerarToken(email: string): Observable<void> { 
    return this.postMethod(email, `${this.END_POINT_BASE}/${this.GERAR_TOKEN}/`);
  }

}
